import { Component, OnInit } from '@angular/core';

import {ServicoApiService} from "../../shared/servico-api.service";
import {ServicoService} from "../../shared/servico.service";
import {UtilService} from "../../../../shared/services/util.service";
import {ServicoBem} from "../../shared/servico.model";
import {FrotasService} from "../../../../bens/frotas/shared/frota.service";
import {FrotaNavigationService} from "../../../../bens/frotas/shared/frota-navigation.service";
import {planoQuery, planosModuleName} from "../../../planos/shared/data.service";
import {PlanoApiService} from "../../../planos/shared/plano-api.service";
import {PlanoService} from "../../../planos/shared/plano.service";
import {AutoCompleteService} from "../../../../shared/components/autocomplete/autocomplete.service";
import {servicoBensStorage, servicosStorage} from "../../shared/data.service";

@Component({
    template: require('./servico-bem-list.component.html'),
    styles: [require('./servico-bem-list.component.css')]
})
export class ServicoBemListComponent implements OnInit {
    list: ServicoBem[] = [];
    loading: boolean = true;
    showDisabled: boolean = false;
    moduleName: any = planosModuleName;

    showFrotaLink: boolean = false;
    frotaDetailHistory: any = {};
    frotaRoute: string;
    frotasModule: any = {};
    showServicoForm: boolean = false;

    planoSelectId: string = 'plano';
    planoQuery: any;
    planoObject: any = {};
    servicoObject: any = {};

    private count: number = 0;

    constructor(
        private _servicoApiService: ServicoApiService,
        private _servicoService: ServicoService,
        private _utilService: UtilService,
        private _frotaService: FrotasService,
        private _frotaNavigationService: FrotaNavigationService,
        private _planoApiService: PlanoApiService,
        private _planoService: PlanoService,
        private _autocompleteService: AutoCompleteService
    ) { }

    ngOnInit() {
        let session: any = this._servicoService.getServicoBemSessionStorage();
        if (session) {
            if (session.servico) {
                this.servicoObject = session.servico;
                this.showServicoForm = true;
                this._servicoService.clearServicoBemSessionStorage();
            }
        }

        this.testFrotaBackHistory();
    }

    clickGoToFrotaDetail() {
        this._frotaService.clearBackStorage();
        this._frotaNavigationService.goToDetail(this.frotaDetailHistory.id, this.frotaRoute);
    }

    clickGoToFrotaList() {
        this._frotaService.clearBackStorage();
        this._frotaNavigationService.goToList(this.frotaRoute);
    }

    clickDelete(item: any) {
        var onDelete = (function() {
            this.onDelete(item);
        }.bind(this));

        this._utilService.swalMessageDelete(onDelete, true);
    }

    clickSave() {
        swal({
                title: "Você deseja realmente salvar este plano?",
                text: "Os serviços vinculados ao plano de manutenção anterior serão removidos!",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Sim, Salvar",
                cancelButtonText: "Fechar",
                closeOnConfirm: false
            },
            function() {
                let list: any[] = [],
                    x: number, lenX: number,
                    obj: any;

                for (x = 0, lenX = this.list.length; x < lenX; x++) {
                    if (this.list[x].planoId === this.planoObject.id || !this.list[x].planoId) {
                        obj = {
                            alertaInicioOdometroHorimetro: this.list[x].alertaInicioOdometroHorimetro,
                            alertaInicioTempo: this.list[x].alertaInicioTempo,
                            periodicidadeOdometroHorimetro: this.list[x].periodicidadeOdometroHorimetro,
                            periodicidadeTempo: this.list[x].periodicidadeTempo,
                            referenciaTempo: this.list[x].referenciaTempo.Key,
                            servicoId: this.list[x].servicoId,
                            ativo: true
                        };

                        if (this.list[x].planoId) {
                            obj.planoId = this.list[x].planoId
                        }
                        list.push(obj);
                    }
                }

                this.saveServicos(list);
            }.bind(this)
        );
    }

    clickToggleServico() {
        this.showServicoForm = !this.showServicoForm;
    }

    getPlanoObject(object: any) {
        this.planoObject = object;
        this.getAllServicosByPlano();
    }

    onSubmitServicoBem(evt: any) {
        evt.bemId = this.frotaDetailHistory.id;

        let obj: any = this._utilService.cloneObject(evt);
        obj.referenciaTempo = obj.referenciaTempo.Key;
        obj.servicoId = obj.servico.id;
        delete obj['servico'];

        this.list.push(evt);
        this.saveServico(obj);
    }

    returnNewServicoObject(object: any) {
        this._servicoService.setServicoBemSessionStorage({moduleRouter: this.frotaRoute});
        let toOtherFormObject: any = {
            descricao: object.text,
            form: servicoBensStorage
        };
        this._autocompleteService.setSessionStorage(toOtherFormObject, servicosStorage);
    }

    planoTemplateResult = (function(state: any) {
        var template: any = this._planoService.templateResult(state, false);
        return template;
    }.bind(this));

    private getAllServicosByBem() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                let x: number, lenX: number,
                    plano: any, list: any[] = [];
                for (x = 0, lenX = Response.length; x < lenX; x++) {
                    if (Response[x].ativo) {
                        Response[x].referenciaTempo = this._planoService.getReferenciaTempo(Response[x].referenciaTempo);
                        if (Response[x].plano) {
                            plano = Response[x].plano;
                        }

                        list.push(Response[x]);
                    }
                }

                if (plano) {
                    this.planoObject = plano;
                    let text = this._autocompleteService.getTextSelect2(this.planoObject, 'titulo');
                    let selectObject: any = {text: text, id: this.planoObject.id};
                    this._autocompleteService.createOptionOnSelect2(this.planoSelectId, selectObject);
                    this._autocompleteService.setValueOnSelect2(selectObject.id, this.planoSelectId);
                }

                this.list = list;
                this.loading = false;
            }
        }.bind(this));

        this._servicoApiService.onGetByBemServicoBem(this.frotaDetailHistory.id, onDone);
    }

    private getAllServicosByPlano() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                Response.forEach(function(item: any) {
                    item.referenciaTempo = this._planoService.getReferenciaTempo(item.referenciaTempo);
                }.bind(this));

                let x: number, lenX: number,
                    list: any[] = Response || [];
                for (x = 0, lenX = this.list.length; x < lenX; x++) {
                    if (this.list[x].planoId && this.list[x].planoId !== this.planoObject.id) {
                        this.list[x].paraRemover = true;
                    }

                    list.push(this.list[x]);
                }

                this.list = list;
            }
        }.bind(this));

        this._servicoApiService.onGetByPlanoServicoPlano(this.planoObject.id, onDone);
    }

    private saveServicos(items: any[]) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this._utilService.swalMessageAddSuccess();
            }
        }.bind(this));

        let obj: any = {
            bemId: this.frotaDetailHistory.id,
            Servicos: items
        };
        this._servicoApiService.onPostServicosBem(obj, onDone);
    }

    private saveServico(item: any) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this._utilService.swalMessageAddSuccess();
            }
        }.bind(this));

        this._servicoApiService.onPostServicoBem(item, onDone);
    }

    private onDelete(item: any) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.list.splice(item[1], 1);

                this._utilService.swalMessageDeleteSuccess();
            } else {
                this._utilService.swalMessageDeleteError();
            }
        }.bind(this));

        if (item.length) {
            if (item[0].bemId) {
                this._servicoApiService.onDeleteServicoBem(item[0].id, onDone);
            } else {
                this.list.splice(item[1], 1);
            }
        }
    }

    private testFrotaBackHistory() {
        const settings: any = this._frotaService.testBackHistory('frota');

        this.frotaDetailHistory = settings.frotaDetailHistory;
        this.frotasModule = settings.frotasModule;
        this.frotaRoute = settings.frotaRoute;
        this.showFrotaLink = settings.showFrotaLink;

        this.planoQuery = this._utilService.cloneObject(planoQuery);
        if (this.frotaDetailHistory){
            if (this.frotaDetailHistory.modelo && this.frotaDetailHistory.modelo.marcaId){
                this.planoQuery.where.and.push({"or":[{"marcaId":this.frotaDetailHistory.modelo.marcaId},{"marcaId":null}]});
                if (this.frotaDetailHistory.modelo.tipoBem) {
                    this.planoQuery.where.and.push({"or":[{"categoriaId": this.frotaDetailHistory.modelo.tipoBem.categoriaId}, {"categoriaId": null}]});
                }
            }
        }
        this.getAllServicosByBem();
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/servicos/servico-bens/servico-bem-list/servico-bem-list.component.ts
 **/